const isTest = process.env.RUNTIME === 'development';
const isAlpha = process.env.RUNTIME === 'alpha';
const isProduction = process.env.RUNTIME === 'production';

export const ENV = {
  isTest,
  isAlpha,
  isProduction,
};

export default ENV;
